"use client";

import { Core } from "@faire/design-tokens";
import { strictLocalize } from "@faire/web/common/localization";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1650))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.146Z
 */
export const Edit = createSVGIcon(
  <>
    <path
      d="M12.8572 15.3856L7.71436 16.2942L8.61436 11.1428L18.3978 1.35934C18.7193 1.03796 19.1552 0.857422 19.6098 0.857422C20.0644 0.857422 20.5003 1.03796 20.8218 1.35934L22.6406 3.1782C22.962 3.49967 23.1426 3.93563 23.1426 4.3902C23.1426 4.84477 22.962 5.28072 22.6406 5.6022L12.8572 15.3856Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5717 16.2856V21.4285C20.5717 21.8831 20.3911 22.3192 20.0696 22.6406C19.7481 22.9621 19.3121 23.1428 18.8574 23.1428H2.57171C2.11705 23.1428 1.68102 22.9621 1.35952 22.6406C1.03803 22.3192 0.857422 21.8831 0.857422 21.4285V5.14275C0.857422 4.6881 1.03803 4.25206 1.35952 3.93057C1.68102 3.60908 2.11705 3.42847 2.57171 3.42847H7.71456"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Edit",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    titleAccess: strictLocalize({
      defaultMessage: "Edit",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    color: Core.icon.default,
  }
);
